import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const HouseholdIncomeChartsDataContext = createContext();

const HouseholdIncomeChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.HOUSEHOLD_INCOME_FAMILIES,
            url: 'governanceroom/dashboard/unifiedregistry/families/household-income'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  averageFamilyIncomeTotal: data?.indicators?.averageFamilyIncomeTotal ?? 0,
                  averageFamilyIncomePerCapita:
                      data?.indicators?.averageFamilyIncomePerCapita ?? 0,
                  averageFamilyBills: data?.indicators?.averageFamilyBills ?? 0,
                  averageFamilyBalance: data?.indicators?.averageFamilyBalance ?? 0
              },
              averageFamilyIncome: data?.averageFamilyIncome ?? [],
              familyBudget: data?.familyBudget ?? [],
              familyIncome: data?.familyIncome ?? [],
              incomeRange: data?.incomeRange ?? [],
          }
        : {
              indicators: {
                  averageFamilyIncomeTotal: 0,
                  averageFamilyIncomePerCapita: 0,
                  averageFamilyBills: 0,
                  averageFamilyBalance: 0
              },
              averageFamilyIncome: [],
              familyBudget: [],
              familyIncome: [],
              incomeRange: [],
          };

    return (
        <HouseholdIncomeChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </HouseholdIncomeChartsDataContext.Provider>
    );
};

export default HouseholdIncomeChartsDataProvider;
